<ng-container *ngIf="searchResult$ | async as searchResult">
  <ng-container *ngIf="searchResult?.breadcrumbs?.length">
    <div class="d-flex flex-wrap active-facet-list py-0">
      <div *ngFor="let breadcrumb of searchResult.breadcrumbs">
        <udex-tag
          [text]="breadcrumb.facetValueName"
          design="Grey"
          icon="decline"
          class="d-block udex-me-8 udex-mb-4"
          (iconClick)="toggleValue(breadcrumb.removeQuery.query.value)"
          (keydown)="toggleValueWithKeyboard($event, breadcrumb.removeQuery.query.value)"
        ></udex-tag>
      </div>
      <udex-tag
        [text]="'search.clearAll' | cxTranslate"
        design="Text"
        icon="decline"
        (selectionChange)="clearAll()"
        (iconClick)="clearAll()"
        (keydown)="clearAllWithKeyboard($event)"
      ></udex-tag>
    </div>
  </ng-container>
</ng-container>
